import PageTransition from "@/components/Commons/PageTransition";

export function PageWrapper({ children }: { children: React.ReactNode }) {
  return <PageTransition>{children}</PageTransition>;
}

export default PageWrapper;
